export const build = { version: process.env?.BUILD_VERSION || 'n/a' };
